// extracted by mini-css-extract-plugin
export default {"MessageContainer":"SuccessMessage_MessageContainer__4VDrA"};